import { PartnerSetting } from './partner-setting'
import { PartnerSettingQuery } from './partner-setting-query'
import { PartnerSettingMutation } from './partner-setting-mutation'

export const entities = [PartnerSetting]
export const resolvers = [PartnerSettingQuery, PartnerSettingMutation]
